import { Vue } from './constants/constants';

const EventBus = new Vue({});
export default EventBus;